import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // User's saved favorite forms
  favorites: [],
  favoritesLoading: false,
  favoritesError: null,

  // Search results (for the Add Favourite modal)
  searchResults: [],
  searchLoading: false,
  searchError: null,

  // Add favorite action
  addLoading: false,
  addError: null,

  // Delete / bulk-delete
  deleteLoading: false,
  deleteError: null,
};

const myFormsSlice = createSlice({
  name: 'myForms',
  initialState,

  reducers: {
    // ── Fetch favorites ───────────────────────────────────────────────────────
    getFavoritesLoading: (state) => {
      state.favoritesLoading = true;
      state.favoritesError = null;
    },
    getFavoritesSuccess: (state, { payload }) => {
      state.favorites = payload;
      state.favoritesLoading = false;
      state.favoritesError = null;
    },
    getFavoritesFailed: (state, { payload }) => {
      state.favoritesLoading = false;
      state.favoritesError = payload;
    },

    // ── Search forms ──────────────────────────────────────────────────────────
    searchFormsLoading: (state) => {
      state.searchLoading = true;
      state.searchError = null;
      state.searchResults = [];
    },
    searchFormsSuccess: (state, { payload }) => {
      state.searchResults = payload;
      state.searchLoading = false;
      state.searchError = null;
    },
    searchFormsFailed: (state, { payload }) => {
      state.searchLoading = false;
      state.searchError = payload;
      state.searchResults = [];
    },
    clearSearchResults: (state) => {
      state.searchResults = [];
      state.searchError = null;
    },

    // ── Add favorite ──────────────────────────────────────────────────────────
    addFavoriteLoading: (state) => {
      state.addLoading = true;
      state.addError = null;
    },
    addFavoriteSuccess: (state, { payload }) => {
      // payload is an array of new favorite objects
      state.favorites = [...state.favorites, ...payload];
      state.addLoading = false;
      state.addError = null;
    },
    addFavoriteFailed: (state, { payload }) => {
      state.addLoading = false;
      state.addError = payload;
    },

    // ── Delete / bulk delete ──────────────────────────────────────────────────
    deleteLoading: (state) => {
      state.deleteLoading = true;
      state.deleteError = null;
    },
    deleteFavoriteSuccess: (state, { payload }) => {
      // payload: array of deleted favorite ids
      state.favorites = state.favorites.filter(
        (fav) => !payload.includes(fav.id)
      );
      state.deleteLoading = false;
      state.deleteError = null;
    },
    deleteFavoriteFailed: (state, { payload }) => {
      state.deleteLoading = false;
      state.deleteError = payload;
    },
  },
});

export const {
  getFavoritesLoading,
  getFavoritesSuccess,
  getFavoritesFailed,
  searchFormsLoading,
  searchFormsSuccess,
  searchFormsFailed,
  clearSearchResults,
  addFavoriteLoading,
  addFavoriteSuccess,
  addFavoriteFailed,
  deleteLoading,
  deleteFavoriteSuccess,
  deleteFavoriteFailed,
} = myFormsSlice.actions;

export default myFormsSlice.reducer;
